<template>
    <el-drawer
        title="消息中心"
        :close-on-press-escape="false"
        :destroy-on-close="true"
        :show-close="false"
        append-to-body
        @close="closeDrawer"
        :visible.sync="drawer">
        <div slot="title">
            <div class="tab-bar p10 relative">
                <el-badge v-for="item in msgTypeList" :value="item.count" :hidden="item.count<=0" class="item mr20">
                    <el-button :type="queryData.msg_type_id==item.key?'primary':'default'" size="mini" @click="updateMsgType(item.key)">{{item.val}}</el-button>
                </el-badge>

                <div class="more-btn">
                    <el-button type="default" size="mini" @click="handleCommand('readAll')">全部标记为已读</el-button>

                    <!--<el-dropdown @command="handleCommand">-->
                    <!--<el-button type="default" icon="el-icon-more" size="mini"></el-button>-->
                    <!--<el-dropdown-menu slot="dropdown">-->
                    <!--<el-dropdown-item command="readAll">全部标记为已读</el-dropdown-item>-->
                    <!--<el-dropdown-item command="delAllRead">删除全部已读消息</el-dropdown-item>-->
                    <!--</el-dropdown-menu>-->
                    <!--</el-dropdown>-->
                </div>
            </div>
            <div class="tool-bar">
                <el-button :type="queryData.read=='2'?'primary':'default'" size="mini" class="mini-button" @click="updateList(2)">全部</el-button>
                <el-button :type="queryData.read=='0'?'primary':'default'" size="mini" class="mini-button" @click="updateList(0)">未读</el-button>
                <el-button :type="queryData.read=='1'?'primary':'default'" size="mini" class="mini-button" @click="updateList(1)">已读</el-button>
                <span class="ml10">共{{list_count}}条</span>
            </div>
        </div>
        <div class="content-wrap" @scroll="listScroll">
            <div class="message-list" v-loading="dataLoading">
                <div v-if="dataList.length<=0&&!dataLoading">
                    <p class="text-color-gray tac">暂无数据</p>
                </div>
                <ul>
                    <li v-for="item in dataList" :key="item.msg_id" class="pointer" @click="openMessage(item)">
                        <template v-if="item.msg_type_id===4">
                            <p class="clearfix">
                            <span class="fl" >
                                <i class="icon iconfont icon-jt-gonggao ver-middle"></i>
                                公告提醒
                            </span>
                                <span class="fr text-color-primary" v-if="item.is_read===0">未读</span>
                                <span class="fr text-color-gray" v-else>已读</span>
                            </p>
                            <p>您有一个新公告【<span class="text-bold word-break"><span v-html="item.title"></span></span>】，请及时查看</p>
                            <p ><span class="text-bold word-break"><span v-html="item.title"></span></span></p>
                        </template>
                        <template v-else-if="item.msg_type_id===3">
                            <p class="clearfix">
                            <span class="fl" >
                                <i class="icon iconfont icon-jt-gonggao ver-middle"></i>
                                通知提醒：<span class="text-bold word-break"><span v-html="item.title"></span></span>
                            </span>
                                <el-button class="fr" size="mini" type="primary" v-if="item.is_read===0" @click.stop="setRead(item)" plain>未读</el-button>
                                <el-button class="fr" size="mini" type="info" v-else @click.stop plain>已读</el-button>
                            </p>
                            <el-tooltip placement="left" :disabled="item.moreTags">
                                <div slot="content" style="max-width: 400px;max-height:50vh;overflow-y: auto" @click="clickCon">
                                    <div v-html="item.message"></div>
                                </div>
                                <div :id="'ref_'+item.msg_id" class="multiple-row-ellipsis-3" v-html="item.message"></div>
                            </el-tooltip>

                        </template>
                        <template v-else>
                            <p class="clearfix">
                                <span class="fr text-color-primary" v-if="item.is_read===0">未读</span>
                                <span class="fr text-color-gray" v-else>已读</span>
                            </p>
                            <p><span class="text-bold word-break">{{item.title}}</span></p>
                        </template>

                        <p class="clearfix">
                            <span class="fr">{{item.creator}} {{item.created_at}}</span>
                        </p>
                    </li>
                    <li class="mt4 mb4" v-if="autoLoading">
                        <p class="tac text-color-gray">数据加载中...</p>
                    </li>
                    <li class="mt4 mb4" v-if="isEnd">
                        <p class="tac text-color-gray">没有更多了</p>
                    </li>
                </ul>
            </div>
        </div>

        <MessageModal ref="messageModal" :msg="activeMsg" @read="setRead"/>
    </el-drawer>
</template>

<script>
    import {mapGetters, mapMutations} from 'vuex'
    import UMCAPI from '@/api/umc';
    import dayjs from 'dayjs';
    import MessageModal from '../modal/messageModal';
    import {ellipseShowPromise} from "@/utils"
    export default {
        name: "MessageDrawer",
        components:{
            MessageModal,
        },
        props:{

        },
        data(){
            return{
                drawer:false,
                msgTypeList:[
                    {key: 0, val: "全部", count: 0},
                    {key: 4, val: "公告", count: 0},
                    {key: 3, val: "通知", count: 0},
                ],
                queryData:{
                    msg_type_id:'0',        // 消息类型 0-全部 1-任务 2-预警 3-提醒 4-公告
                    read:'2',    // 是否已读 0未读 1已读 2全部
                    page:1,     // 分页 默认1
                    limit:10,
                },
                list_count:0,
                total_page:0,
                dataList:[],
                dataLoading:false,
                activeMsg:{},
                autoLoading:false,
                loadTimer:null,
                isEnd:false,
            }
        },
        computed:{
            ...mapGetters([
                'umc_token',
            ]),
            headers(){
                return {
                    headers:{
                        authorization:this.umc_token,
                    }
                }
            },
        },
        methods:{
            ...mapMutations('workOrder', [
                'SET_SHOW_QUEUE_MODAL',
            ]),
            showDrawer(){
                this.drawer = true;
                this.queryData.msg_type_id = '0';
                this.queryData.read = '2';
                this.queryData.page = 1;
                this.getMessageList();
                this.getMessageCount();
            },
            handleCommand(val){
                // this.$message.success(val);
                if(val=='readAll'){
                    if(this.queryData.read=='1') return;
                    UMCAPI.batchMarkingRead({
                        msg_type_id:this.queryData.msg_type_id,
                    },this.headers).then(()=>{
                        this.getMessageCount();
                        this.dataList.forEach(item=>{
                            item.is_read = '1';
                        })
                    },err=>{
                        console.log('umc batchMarkingRead err',err);
                    })
                }
            },
            getMessageList(isLoad){
                if(isLoad!=='append'){
                    this.dataList = [];
                }
                this.dataLoading = true;
                UMCAPI.getMessageList(this.queryData,this.headers).then(res=>{
                    let resData = res.data||{};
                    let list = resData.list||[];

                    if(isLoad==='append'){
                        list.forEach(item=>{
                            item.moreTags = true
                            item.created_at = dayjs(item.created_at*1000).format('YYYY-MM-DD HH:mm:ss');
                            this.dataList.push({...item});
                        });
                        this.autoLoading = false;
                        this.isEnd =  resData.total_page<=this.queryData.page;
                    }else{
                        this.isEnd = false;
                        this.dataList = list.map(item=>{
                            item.moreTags = true
                            item.created_at = dayjs(item.created_at*1000).format('YYYY-MM-DD HH:mm:ss');
                            return item;
                        });
                    }
                    this.list_count = resData.list_count||0;
                    this.total_page = resData.total_page||0;
                    this.dataLoading = false;

                    // 添加是否显示提示判断
                    this.$nextTick(()=>{
                        this.dataList.forEach((item)=>{
                            let tags_ele = this.$el.querySelector(`#ref_${item.msg_id}`)
                            if(tags_ele && tags_ele.offsetHeight && tags_ele.scrollHeight && (tags_ele.scrollHeight > tags_ele.offsetHeight)) {
                                item.moreTags = false   // 显示提示
                            }else{
                                item.moreTags = true
                            }
                        })

                    })
                },err=>{
                    console.log('umc getMessageList err',err);
                    this.dataLoading = false;
                })
            },
            updateMsgType(val){
                this.queryData.msg_type_id = val;
                this.queryData.page = 1;
                this.queryData.read = '2';
                this.getMessageList();
            },
            updateList(val){
                this.queryData.read = val;
                this.queryData.page = 1;
                this.getMessageList();
            },
            openMessage(msg){
                let msgType = msg.msg_type_id||'';
                if(msgType=='3'){
                    /* 通知类 */
                    this.setRead(msg);
                    this.$emit('open',msg);
                    let $html = new DOMParser().parseFromString(msg.message, 'text/html');
                    let $msgDesc = $html.querySelector('.msg-desc');
                    if(!$msgDesc) return this.$message.error('当前消息没有可以跳转的内容');
                    let taskId = $msgDesc.getAttribute("data-id");
                    let taskType = $msgDesc.getAttribute("data-type");
                    console.log('-', taskType)
                    if(taskType=='daily_task_detail'){
                        this.$router.push({
                            name:'daily_task',
                            params:{
                                pageType:taskType,
                                search:taskId,
                            },
                            query: {
                                date: new Date().getTime(),
                            },
                        });
                        this.drawer = false;
                    }else if(taskType=='mi_batch_task_list'){
                        this.$router.push({
                            name:'mi_batch_create',
                            params:{
                                pageType:taskType,
                                search:taskId,
                            },
                            query: {
                                date: new Date().getTime(),
                            },
                        });
                        this.drawer = false;
                    }else if(taskType=='mi_batch_v2_task_list'){
                        this.$router.push({
                            name:'mi_batch_v2_create',
                            params:{
                                pageType:taskType,
                                search:taskId,
                            },
                            query: {
                                date: new Date().getTime(),
                            },
                        });
                        this.drawer = false;
                    }else if(taskType=='pop_notification'){
                        /*type:pop_notification 通知，但是要弹窗展示内容 */
                        this.activeMsg = {...msg};
                        this.$refs.messageModal.showModal();
                    }else if(taskType == 'TaskInfoPage') {
                        // 跳工单管理 > 任务管理 > 工单详情
                        let tabsId = $msgDesc.getAttribute("data-tabs");
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'TaskInfoPage',
                                id:taskId,
                                tagsActive: tabsId,
                                show_type: false
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType == 'AssignInfoPage') {
                        // 跳工单管理 > 指派 > 工单详情
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'AssignInfoPage',
                                id:taskId,
                                tagsActive: 1
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType == 'createPage') {
                        // 跳工单管理 > 修改工单   新版已去除 后期可删掉 未删原因 兼容下以前的旧消息

                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'createPage',
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType == 'MaterialInfoPage') {
                        // 跳工单管理 > 工单详情
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'MaterialInfoPage',
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType == 'ScheduleManage') {
                        // 跳工单管理 > 排单管理（子tab由 data-tabs 决定：1待排期超期→待排单 / 2撤回→已排单·默认已排单）
                        let tabsId = $msgDesc.getAttribute("data-tabs");
                        let subTab = tabsId == '1' ? 'pool' : 'pending';
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'ScheduleManagePage',
                                subTab: subTab,
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType == 'Approval') {
                        // 跳工单管理 > 排单管理 > 审批 tab
                        let $router = this.$router.resolve({
                            name:'work_order_material',
                            query: {
                                topage:'ScheduleManagePage',
                                subTab:'approval',
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType == 'workProcessingCenter') {
                        // 工单任务处理中心
                        this.drawer = false;
                        this.$nextTick(()=>{
                            this.SET_SHOW_QUEUE_MODAL(taskId)
                        })
                    }else if(taskType === 'AdBatchAdjustmentPage') {
                        // 广告批量调控
                        console.log('-', taskType)
                        let $router = this.$router.resolve({
                            name:'ad_batch_adjustment',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType === 'vivo_batch_task_list') {
                        // vivo批量任务列表
                        let $router = this.$router.resolve({
                            name:'vivo_batch_create',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='oppo_plan_copy'){
                        let $router = this.$router.resolve({
                            name:'oppo_plan_copy',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='huawei_ads'){
                        let $router = this.$router.resolve({
                            name:'huawei_ads',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else if(taskType=='honor'){
                        let $router = this.$router.resolve({
                            name:'honor',
                            query: {
                                id:taskId
                            },
                            params:{
                                menuReload: 1
                            }
                        });
                        this.drawer = false;
                        window.open($router.href, '_blank');
                    }else{
                        this.$message.error('当前消息没有可以跳转的内容');
                    }
                }else{
                    this.activeMsg = {...msg};
                    this.$refs.messageModal.showModal();
                }
            },
            setRead(msg){
                let actionMsg = this.dataList.find(item=>item.msg_id==msg.msg_id);
                UMCAPI.markRead({
                    msg_id:msg.msg_id,
                },this.headers).then(res=>{
                    actionMsg.is_read = 1;
                    this.getMessageCount();
                    this.$emit('close')
                },err=>{
                    console.log('umc markRead err',err);
                });
            },
            getMessageCount(){
                UMCAPI.getMessageCount({},this.headers).then(res=>{
                    let resData = res.data||{};
                    let list = resData.list||[];
                    this.msgTypeList.forEach(item=>{
                        let data = list.find(inner=>inner.key==item.key);
                        if(data){
                            item.count = data.count;
                        }
                    })
                },err=>{
                    console.log('umc getMessageCount err',err);
                })
            },
            closeDrawer(){
                this.$emit('close');
            },
            listScroll(e){
                let $contentWrap = e.target;        // $content-wrap
                let $list = $contentWrap.querySelector('.message-list');
                let $listHeight = $list.clientHeight;
                if($contentWrap.scrollTop>0){
                    if($listHeight - $contentWrap.clientHeight <$contentWrap.scrollTop-5){
                        if(this.autoLoading) return ;
                        if(this.queryData.page>=this.total_page) return;
                        if(this.loadTimer){
                            clearTimeout(this.loadTimer);
                            this.loadTimer = null;
                        }
                        this.loadTimer = setTimeout(()=>{
                            this.autoLoading = true;
                            this.queryData.page = this.queryData.page+1;
                            this.getMessageList('append');
                        },300)
                    }

                }
            },
            // 只处理 通知- 智能托管 tips里的跳转
            clickCon(e){
                let $target = e.target;
                let classList = Array.from($target.classList);
                if(classList.includes('action-btn')){
                    let dataPage = $target.getAttribute('data-page');
                    let dataId = $target.getAttribute('data-id');
                    let rangeTime = $target.getAttribute('range-time');
                    if(dataPage=="intelligentTriggerRecordPage"){
                        let $router = this.$router.resolve({
                            name:'intelligent_managed_rule',
                            query: {
                                url:'TriggerRecordPage',
                                id:dataId,
                                range_time:rangeTime,
                                t: new Date().getTime(),
                            },
                        });
                        window.open($router.href, '_blank');
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    ::v-deep .el-drawer__header{
        padding: 0;
        margin-bottom: 5px;
    }
    ::v-deep .el-drawer__body{
        overflow: hidden;
    }

    .tab-bar{
        border-bottom: solid 1px #ccc;
        padding-left: 20px;


        .more-btn{
            position: absolute;
            right: 10px;
            top: 10px;
            &::v-deep button{
                padding: 7px;
            }
        }
    }

    .tool-bar{
        padding: 10px 20px;
        .mini-button{
            padding: 5px 10px;
        }
    }

    .content-wrap{
        height: calc(100vh - 95px);
        overflow: auto;
        max-height: 920px;
    }

    .message-list{
        padding: 0 20px;

        li{
            margin-bottom: 10px;
            padding: 10px;
            background-color: #f8f8f9;
            border-radius: 5px;
            &:hover{
                background-color: #efefef;
            }

            .word-break{
                word-wrap: break-word;
            }
        }
    }



</style>
